import React from 'react';
import PropTypes from 'prop-types';

import styles from './MenuOption.scss';

const MenuOption = ({ src, selected }) => (
  <div className={`${styles.MenuOption} ${selected ? styles.selected : ''}`}>
    <i className={styles[src]} />
  </div>
);

MenuOption.defaultProps = {
  selected: false
};

MenuOption.propTypes = {
  src: PropTypes.string.isRequired,
  selected: PropTypes.bool
};

export default MenuOption;



// WEBPACK FOOTER //
// ./src/components/MenuOption/MenuOption.js